import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, LazyImage, SvgIcon } from '@teko/ui';

const Wrapper = styled.div`
  display: flex;
`;
const Info = styled.div`
  margin-left: 0.5rem;
`;
const Fullname = styled.h5`
  font-size: 1rem;
`;
const Title = styled.h6`
  margin-bottom: 0;
  font-weight: 400;
  font-size: 0.8rem;
`;
const UserCard = ({
  name,
  picture
}) => /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("div", null, picture ? /* @__PURE__ */ React.createElement(LazyImage, {
  src: picture,
  height: 44,
  width: 44
}) : /* @__PURE__ */ React.createElement(SvgIcon, {
  name: "account",
  size: 32
})), /* @__PURE__ */ React.createElement(Info, null, /* @__PURE__ */ React.createElement(Title, null, t("T\xE0i kho\u1EA3n c\u1EE7a")), /* @__PURE__ */ React.createElement(Fullname, null, name)));

export { UserCard };
